import * as React from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";

interface NewChatButtonProps {
    disabled: boolean;
    onClick: () => void;
}

/**
 * "New chat" in the overlay header.
 *
 * Earns its place because follow-ups carry context: without it a user who moves
 * on to an unrelated question drags the old one along with no way to say
 * otherwise.
 */
export default function NewChatButton({
    disabled,
    onClick,
}: NewChatButtonProps): React.JSX.Element {
    return (
        <Box
            component="button"
            type="button"
            disabled={disabled}
            onClick={onClick}
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                height: 34,
                px: 1.5,
                borderRadius: 999,
                border: 0,
                bgcolor: "rgba(255,255,255,0.06)",
                color: "#C3CFE6",
                fontFamily: "inherit",
                fontSize: 12.5,
                fontWeight: 600,
                whiteSpace: "nowrap",
                flexShrink: 0,
                cursor: disabled ? "default" : "pointer",
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <RefreshIcon sx={{ fontSize: 15 }} />
            New chat
        </Box>
    );
}
